import {
  useToastController,
  useId,
  Toaster,
  Toast,
  ToastTitle,
  ToastBody,
  makeStyles
} from "@fluentui/react-components";

const useStyles = makeStyles({
  title: {
    fontWeight: 600,
    fontSize: "14px",
  },
});

export const useFluentToast = (position = "top-end", inline = false) => {
  const toasterId = useId("fluent-toast");
  const { dispatchToast } = useToastController(toasterId);
  const styles = useStyles();

  const showToast = (title, message, intent = "success") => {
    dispatchToast(
      <Toast>
        <ToastTitle className={`${styles.title}`}>{title}</ToastTitle>
        <ToastBody>{message}</ToastBody>
      </Toast>,
      { intent}

    );
  };

  return {
    showToast,
    FluentToast: <Toaster toasterId={toasterId} position={position} inline={inline}/>,
  };
};
